module.exports = __webpack_public_path__ + "img/zbrush4.e43304d2.png";